// extracted by css-extract-rspack-plugin
export default {"list":"NavSubgroup_list__jiwev","name":"NavSubgroup_name__uaMf7"};